import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { FaClone } from "react-icons/fa";
import EmailInput from "../../UI/EmailInput";

const SendForReview = () => {
  const { camp_id } = useParams();

  const anchorLink = `https://www.vidconnect.net/page/${camp_id}`;

  const [copytext, setCopytext] = useState(`Copy Link`);

  const [addNotechk, setAddNotechk] = useState(false);

  const [addEmails, setAddEmails] = useState([]);
  const [errors, setErrors] = useState({
    emailValid: false,
  });

  const handleCopy = (e) => {
    /* Get the text field */
    var copyText = anchorLink;
    /* Copy the text inside the text field */
    navigator.clipboard.writeText(copyText);

    setCopytext("Copied!");

    setTimeout(function () {
      setCopytext("Copy Link");
    }, 2000);
  };

  // const handleEmails = (e) =>{
  //     e.preventDefault();
  //     console.log('here')
  //     setAddEmails([...addEmails])
  // }

  const handleSentMail = (e) => {};

  return (
    <>
      <div className="modal popup2" id="myModal5">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Get Your Video Reviewed</h4>
              <button
                type="button"
                className="btn_close2"
                data-bs-dismiss="modal"
              >
                <i className="fa fa-close"></i>
              </button>
            </div>

            <div className="modal-body p-4">
              <form>
                <div className="sharevialink">
                  <h5 className="mb-2">
                    <strong>Share via link</strong>
                  </h5>
                  <div className="position-relative mb-4">
                    <input
                      type="text"
                      className="form-control shadow-none txt_f_2"
                      placeholder="https://www.freepik.com/free-vector/woman-link-man..."
                      defaultValue={anchorLink}
                      readOnly
                    />

                    <button
                      type="button"
                      className="copy_link_btn border-0 p-0"
                      onClick={handleCopy}
                    >
                      <i>
                        <FaClone className="me-1" />
                      </i>
                      {copytext}
                    </button>
                  </div>
                </div>

                <div className="addpeoplebx mb-4">
                  <h5 className="mb-2">
                    <strong>Add People</strong>
                  </h5>
                  <div className="addp_rw bg-white  p-0 border-0 rounded-1 ">
                    {/* <ul className="m-0 p-0 list-unstyled">
                                            <li>
                                                <a href="#0">shailesh@sitestokes.com 
                                                    <span className="close_btn3">
                                                        <i><img src={process.env.PUBLIC_URL + "/assets/images/close2.png"} width="10" height="9" alt="img" /></i>
                                                    </span>
                                                </a>
                                            </li>
                                        </ul> */}

                    <EmailInput
                      selectedEmails={addEmails}
                      setAddEmails={setAddEmails}
                      setErrors={setErrors}
                    />
                  </div>
                  {errors.emailValid && (
                    <p className="m-0 pink_clor font12">
                      Please enter a valid email address
                    </p>
                  )}
                </div>
                {addNotechk && (
                  <textarea
                    className="form-control border shadow-none height100 mb-4"
                    placeholder="Enter the message you wish to convey"
                  ></textarea>
                )}

                <div className="rw d-flex justify-content-between align-items-center">
                  <div className="form-check">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id="addnote"
                      checked={addNotechk}
                      onChange={(e) => setAddNotechk(!addNotechk)}
                    />
                    <label className="form-check-label" htmlFor="addnote">
                      Add a note
                    </label>
                  </div>
                  <input
                    type="button"
                    className="btn btn1"
                    value="Send Out For Review"
                    onClick={handleSentMail}
                  />
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SendForReview;
